'use client';

import { useState, useEffect } from 'react';

// Force static generation
export const dynamic = 'force-static';

const Dsmi = () => {
  const [isChecked, setIsChecked] = useState(false);

  // 从localStorage读取初始状态
  useEffect(() => {
    const storedValue = localStorage.getItem('doNotShareInfo');
    if (storedValue !== null) {
      setIsChecked(JSON.parse(storedValue));
    }
  }, []);

  // 保存状态到localStorage
  useEffect(() => {
    localStorage.setItem('doNotShareInfo', JSON.stringify(isChecked));
  }, [isChecked]);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 via-white to-blue-50 min-h-screen text-gray-800">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="bg-white/90 shadow-xl p-8 md:p-10 border border-gray-100">
          <h3 className="text-xl font-semibold mb-5 text-gray-900">
            Your Privacy Choices
          </h3>

          <p className="text-gray-700 mb-2">Last Revised: Nov 13, 2025</p>

          <p className="text-gray-700 mb-4 leading-relaxed">
            Depending on what state you live in, you may have the right to opt out of "sales" of your personal information, sharing of personal information for cross-contextual behavioral advertising ("sharing"), or "processing of personal data for targeted advertising" as defined in applicable privacy law. Please read below for more information about these activities and how to opt out.
          </p>

          <p className="text-gray-700 mb-4 leading-relaxed">
            We do not sell personal information for monetary consideration, but we may disclose your information to third-party partners (including through the use of tracking technologies such as cookies and pixels) for the purpose of tailoring and displaying relevant advertisements to you on our site and on other platforms, as well as analyzing our advertising efforts. This data we may disclose does not identify you by name or other directly identifiable means. Rather, it is about the basic information related to your browser, device identifiers, your general location, and the content and advertising you view on our site and mobile application. However, as further described in our
            <a href="/privacy" className="text-blue-600 underline">
              Privacy Policy
            </a>
            ,these types of disclosures may constitute "sales," "sharing," or "processing of personal data for targeted advertising" under certain US state privacy laws.

          </p>

          <p className="text-gray-700 mb-4 leading-relaxed">
            If your state provides you with the right to opt out of "selling," "sharing," or "processing of personal data for targeted advertising" and you would like to exercise these rights, please check the box titled "Do Not Share My Information below". Please note that opting out does not mean that you will stop seeing all ads.
          </p>

          <label className="flex items-center text-gray-700 mb-4 cursor-pointer">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
              className="w-4 h-4 mr-2"
              aria-label="Do Not Share My Information"
            />
            <strong>Do Not Share My Information</strong>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Dsmi;
